/** enum for rating types */
export enum CsatRatingTypes {
  version_1 = 'v1',
  version_2 = 'v2',
}
